import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../api/client.js';
import type { AuditEntry } from '../../api/types.js';
import { Alert, Card, Spinner } from '../../components/ui.js';
import { AuditTable } from '../../components/AuditTable.js';

function useAudit() {
  return useQuery({
    queryKey: ['audit'],
    queryFn: () => apiFetch<{ entries: AuditEntry[] }>('/audit').then((r) => r.entries),
  });
}

/** Staff view of who did what, and when. */
export function AuditPage() {
  const { data, isPending, isError } = useAudit();

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="font-title text-3xl tracking-wide">Audit log</h1>
        <p className="opacity-70">Recent actions across the platform, newest first.</p>
      </div>

      {isPending ? (
        <Spinner />
      ) : isError ? (
        <Alert>Could not load the audit log.</Alert>
      ) : (
        <Card>
          <AuditTable entries={data} />
        </Card>
      )}
    </div>
  );
}
